import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { SearchPage } from './pages/SearchPage';
import { DocumentPage } from './pages/DocumentPage';
import { TimelinePage } from './pages/TimelinePage';
import { SegmentsPage } from './pages/SegmentsPage';
import { FavoritesPage } from './pages/FavoritesPage';
import { NotesPage } from './pages/NotesPage';
import { AdminPage } from './pages/AdminPage';
import { GraphPage } from './pages/GraphPage';
import { RagPage } from './pages/RagPage';
import { ActualPage } from './pages/ActualPage';
import { ActualDocumentPage } from './pages/ActualDocumentPage';
import { TopicsPage } from './pages/TopicsPage';

const App: React.FC = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/document/:id" element={<DocumentPage />} />
        <Route path="/actual" element={<ActualPage />} />
        <Route path="/actual/document/:id" element={<ActualDocumentPage />} />
        <Route path="/timeline" element={<TimelinePage />} />
        <Route path="/segments" element={<SegmentsPage />} />
        <Route path="/favorites" element={<FavoritesPage />} />
        <Route path="/notes" element={<NotesPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/graph" element={<GraphPage />} />
        <Route path="/rag" element={<RagPage />} />
        <Route path="/topics" element={<TopicsPage />} />
      </Routes>
    </Layout>
  );
};

export default App;
